(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-gallery"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__rclColorCycleInit) return;
    window.__rclColorCycleInit = true;

    // Every card keeps a "side" (front or back) and the colour it is showing. The 5-second colour cycle keeps running
    // whatever the side: a card that is showing its back slides to the NEXT colour's back, so the back view travels
    // with everything else. Hovering (desktop) or tapping the flip button (phone) only changes the side.
    var order = ["Black","Navy","Red","White","Blossom","Chambray","Crimson","Grey","Ivory","Mustard","Pepper","Royal Caribe","Sage","True Navy"];
    var idx = 0;
    var SLIDE_MS = 600;
    window.__rclCurrentColor = order[0];

    function getActiveImg(el) {
      var active = el.querySelector('img[data-cycle-active]');
      if (active) return active;
      var img = el.querySelector('img');
      if (img) img.setAttribute('data-cycle-active', 'true');
      return img;
    }

    function slideTo(el, url) {
      var oldImg = getActiveImg(el);
      if (!oldImg || !oldImg.parentNode) return;

      var newImg = oldImg.cloneNode(true);
      newImg.removeAttribute('srcset');
      newImg.removeAttribute('sizes');
      newImg.removeAttribute('data-cycle-active');
      newImg.src = url;

      var travelPx = el.clientWidth || el.offsetWidth || 300;

      [oldImg, newImg].forEach(function (im) {
        im.style.position = 'absolute';
        im.style.inset = '0';
        im.style.width = '100%';
        im.style.height = '100%';
        im.style.transition = 'transform ' + SLIDE_MS + 'ms ease';
      });
      newImg.style.transform = 'translateX(' + travelPx + 'px)';
      oldImg.removeAttribute('data-cycle-active');

      oldImg.parentNode.insertBefore(newImg, oldImg.nextSibling);
      newImg.setAttribute('data-cycle-active', 'true');

      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          oldImg.style.transform = 'translateX(-' + travelPx + 'px)';
          newImg.style.transform = 'translateX(0)';
        });
      });

      setTimeout(function () {
        if (oldImg.parentNode) oldImg.parentNode.removeChild(oldImg);
      }, SLIDE_MS + 50);
    }

    function fileOf(u) { return (u || '').split('?')[0].split('/').pop(); }

    function mapsOf(card) {
      var front = {}, back = {};
      try { front = JSON.parse(card.getAttribute('data-color-cycle') || '{}'); } catch (e) {}
      try { back = JSON.parse(card.getAttribute('data-color-backmap') || '{}'); } catch (e) {}
      return { front: front, back: back };
    }

    // The colour this card is showing right now (hoodies only have 4 of the 14 cycle colours).
    function colorOf(card) {
      if (card.dataset.rclColor) return card.dataset.rclColor;
      var img = getActiveImg(card);
      if (!img) return null;
      var f = fileOf(img.currentSrc || img.src), m = mapsOf(card), c;
      for (c in m.front) { if (fileOf(m.front[c]) === f) return c; }
      for (c in m.back) { if (fileOf(m.back[c]) === f) return c; }
      return null;
    }

    function urlFor(card, color, side) {
      var m = mapsOf(card);
      if (side === 'back' && m.back[color]) return m.back[color];
      return m.front[color] || null;
    }

    // Shirts and hoodies open on their BACK; hovering (desktop) or tapping the flip button (phone) shows the FRONT.
    // Cards without a real back photo (mugs) keep their first picture and show the second one on hover.
    function hasRealBacks(card) {
      var m = mapsOf(card), ks = Object.keys(m.back);
      return ks.length > 0 && ks.every(function (k) { return /-back(_[0-9a-f-]+)?\.jpg/.test(m.back[k]); });
    }
    function defaultSide(card) { return hasRealBacks(card) ? 'back' : 'front'; }
    function otherSide(side) { return side === 'back' ? 'front' : 'back'; }

    function setSide(card, side) {
      var color = colorOf(card);
      if (!color) return;
      var url = urlFor(card, color, side);
      if (!url) return;
      card.dataset.rclSide = side;
      card.dataset.rclColor = color;
      var pre = new Image(); // load first so there is no blank flash
      pre.onload = function () {
        var cur = getActiveImg(card);
        if (!cur) return;
        cur.removeAttribute('srcset'); // an image with srcset ignores src changes
        cur.removeAttribute('sizes');
        cur.src = url;
      };
      pre.src = url;
    }

    function tick() {
      idx = (idx + 1) % order.length;
      var color = order[idx];
      window.__rclCurrentColor = color;
      document.querySelectorAll('[data-color-cycle]').forEach(function (el) {
        var m = mapsOf(el);
        if (!m.front[color]) return;
        var url = urlFor(el, color, el.dataset.rclSide === 'back' ? 'back' : 'front');
        if (!url) return;
        el.dataset.rclColor = color;
        slideTo(el, url);
      });
    }

    setInterval(tick, 5000);

    function findCard(node) {
      while (node && node !== document.body) {
        if (node.classList && node.classList.contains('card-gallery')) return node;
        node = node.parentElement;
      }
      return null;
    }

    var canHover = function () { return window.matchMedia && window.matchMedia('(hover: hover)').matches; };

    document.addEventListener('mouseover', function (e) {
      if (!canHover()) return; // phones: the flip button does this
      var card = findCard(e.target);
      if (!card || card.contains(e.relatedTarget)) return;
      setSide(card, otherSide(defaultSide(card)));
    });

    document.addEventListener('mouseout', function (e) {
      if (!canHover()) return;
      var card = findCard(e.target);
      if (!card || card.contains(e.relatedTarget)) return;
      setSide(card, defaultSide(card));
    });

    function addFlipButton(card) {
      if (card.querySelector('.rcl-flip')) return;
      var m = mapsOf(card);
      if (!Object.keys(m.back).length) return;
      if (!hasRealBacks(card)) return; // no real back photo (e.g. mugs): no flip button
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'rcl-flip';
      btn.setAttribute('aria-label', 'Flip to see the other side');
      btn.innerHTML = '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" d="M20 11a8 8 0 0 0-14.9-3M4 4v4h4M4 13a8 8 0 0 0 14.9 3M20 20v-4h-4"/></svg>';
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation(); // don't open the product
        setSide(card, otherSide(card.dataset.rclSide || defaultSide(card)));
      });
      card.appendChild(btn);
    }

    function initCard(card) {
      if (card.dataset.rclInit) return;
      card.dataset.rclInit = '1';
      if (hasRealBacks(card)) setSide(card, 'back'); // open on the back
    }

    function addFlipButtons() {
      document.querySelectorAll('.card-gallery[data-color-backmap]').forEach(function (card) {
        initCard(card);
        addFlipButton(card);
      });
    }
    addFlipButtons();
    new MutationObserver(addFlipButtons).observe(document.body, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-media-gallery-content"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__rclBackHoverInit) return;
    window.__rclBackHoverInit = true;

    function getSelectedColor() {
      var input = document.querySelector('input[data-option-name="Color"]:checked');
      return input ? input.value : null;
    }

    function findTile(node) {
      while (node && node !== document.body) {
        if (node.classList && node.classList.contains('product-media-container')) return node;
        node = node.parentElement;
      }
      return null;
    }

    function getTileColor(tile) {
      return tile.getAttribute('data-tile-color') || getSelectedColor();
    }

    document.addEventListener('mouseover', function (e) {
      var tile = findTile(e.target);
      if (!tile) return;
      if (tile.contains(e.relatedTarget)) return;
      var gallery = tile.closest('media-gallery[data-color-backmap]');
      if (!gallery) return;
      var map;
      try {
        map = JSON.parse(gallery.getAttribute('data-color-backmap'));
      } catch (err) {
        return;
      }
      var color = getTileColor(tile);
      if (!color) return;
      var backUrl = map[color];
      if (!backUrl) return;
      var img = tile.querySelector('img');
      if (!img) return;
      if (!img.dataset.origSrc) img.dataset.origSrc = img.src;
      img.src = backUrl;
    });

    document.addEventListener('mouseout', function (e) {
      var tile = findTile(e.target);
      if (!tile) return;
      if (tile.contains(e.relatedTarget)) return;
      var img = tile.querySelector('img');
      if (img && img.dataset.origSrc) {
        img.src = img.dataset.origSrc;
        delete img.dataset.origSrc;
      }
    });

    // Phone flip button on each front/back photo of the product page gallery.
    // File names look like "<product>-<colour>-front_<random>.jpg" (Shopify adds the random part when a photo is replaced),
    // so the other side is found by looking for the gallery photo with the same product+colour and the opposite side.
    var SIDE_RE = /-([a-z0-9-]+?)-(front|back)(?:_[0-9a-f-]+)?\.jpg/i;
    function parseSide(src) {
      var m = SIDE_RE.exec(src || '');
      return m ? { key: m[1].toLowerCase(), side: m[2].toLowerCase() } : null;
    }

    function otherSideImg(tile, img) {
      var p = parseSide(img.getAttribute('src') || img.getAttribute('srcset'));
      if (!p) return null;
      var want = p.side === 'front' ? 'back' : 'front';
      var scope = tile.closest('media-gallery') || document;
      var list = scope.querySelectorAll('img');
      for (var k = 0; k < list.length; k++) {
        var q = parseSide(list[k].getAttribute('src') || list[k].getAttribute('srcset'));
        if (list[k] !== img && q && q.key === p.key && q.side === want) return list[k];
      }
      return null;
    }

    function addPdpFlip(tile) {
      if (tile.querySelector('.rcl-pdp-flip')) return;
      var img = tile.querySelector('img');
      if (!img) return;
      var probe = img.getAttribute('src') || img.getAttribute('srcset') || '';
      if (!parseSide(probe)) return; // only our model photos
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'rcl-pdp-flip';
      btn.setAttribute('aria-label', 'Flip to see the other side');
      btn.innerHTML = '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true"><path fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" d="M20 11a8 8 0 0 0-14.9-3M4 4v4h4M4 13a8 8 0 0 0 14.9 3M20 20v-4h-4"/></svg>';
      tile.appendChild(btn);
    }

    function flipTile(tile) {
      var cur = tile && tile.querySelector('img');
      if (!cur) return;
      var other = otherSideImg(tile, cur);
      if (!other) return;
      var url = other.currentSrc || other.getAttribute('src');
      var sset = other.getAttribute('srcset');
      var pre = new Image(); // load the other side first so there is no flash
      pre.onload = function () {
        cur.setAttribute('src', other.getAttribute('src') || url);
        if (sset) cur.setAttribute('srcset', sset); else cur.removeAttribute('srcset');
      };
      pre.src = url;
    }

    // The theme opens the zoom dialog from a click anywhere on the photo, so catch the click at the very top
    // (window, capture phase) and stop it there before the theme sees it.
    window.addEventListener('click', function (e) {
      var b = e.target && e.target.closest ? e.target.closest('.rcl-pdp-flip') : null;
      if (!b) return;
      e.preventDefault();
      e.stopPropagation();
      flipTile(b.closest('.product-media-container'));
    }, true);

    function addPdpFlips() {
      document.querySelectorAll('media-gallery .product-media-container').forEach(addPdpFlip);
    }
    addPdpFlips();
    new MutationObserver(addPdpFlips).observe(document.body, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

})();
